import React, { useState } from "react";
import { Button, Tooltip, Typography } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";

const { Text } = Typography;

// Stripe-style key prefixes ("sk_test_", "pk_live_", ...) aren't secret
const KEY_PREFIX = /^(sk|pk|rk)_(test|live)_/;

// Only the last 4 characters are shown:
// "sk_test_KagBiOGrc6QGPU1zZ5cZTICs" -> "sk_test_••••••••TICs"
// "A7F3-99QK-12ZX"                   -> "••••••••12ZX"
const mask = (value) => {
  if (value.length <= 8) return "•".repeat(value.length);

  const prefix = (value.match(KEY_PREFIX) || [""])[0];
  return `${prefix}••••••••${value.slice(-4)}`;
};

/**
 * Sensitive value (keys, secret codes): masked by default, with a
 * show/hide toggle and a copy button.
 */
const SecretValue = ({ value }) => {
  const [visible, setVisible] = useState(false);

  if (value === null || value === undefined || value === "") return "--";

  const text = String(value);

  return (
    <span className="secret-value">
      <Text
        className="secret-value__text"
        copyable={{ text, tooltips: ["Copy", "Copied"] }}
      >
        {visible ? text : mask(text)}
      </Text>
      <Tooltip title={visible ? "Hide" : "Show"}>
        <Button
          type="text"
          size="small"
          className="secret-value__toggle"
          icon={visible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
          onClick={() => setVisible((prev) => !prev)}
          aria-label={visible ? "Hide value" : "Show value"}
        />
      </Tooltip>
    </span>
  );
};

export default SecretValue;
